<template>
    <thead class="thead-sticky">
        <tr>
            <th class="column-seat-type" rowspan="2">
                {{ trans["seat-type"] }}
            </th>

            <th
                :class="'column-' + groupsFrom(dates)[0].slug"
                :colspan="dayoff == 0 ? 2 : 1"
            >
                {{ groupsFrom(dates)[0].name }}
            </th>
            <th
                :class="'column-' + groupsFrom(dates)[2].slug"
                :colspan="dayoff <= 2 ? 3 : 1"
            >
                {{ groupsFrom(dates)[2].name }}
            </th>
            <th :class="'column-' + groupsFrom(dates)[5].slug" :colspan="1">
                {{ groupsFrom(dates)[5].name }}
            </th>
        </tr>
        <tr>
            <th
                v-for="(group, key) in dates"
                :key="'head-' + key"
                :class="
                    'column-' +
                        group.slug +
                        '-day column-' +
                        group.slug +
                        '-day-' +
                        key
                "
            >
                {{ group.date }}
            </th>
        </tr>
    </thead>
</template>

<style lang="scss" scoped>
tr {
    background: transparent;
    border: 0;
    padding: 10px 0;
}

th {
    padding: 1em 0.5em;
    border-radius: 0;
    color: #fff;
    text-align: center;
    font-weight: 700;
}

.thead-sticky {
    position: sticky;
    top: 0px;
    z-index: 2;
}

.column-seat-type {
    background-color: var(--color-gray-light);
    color: var(--color-gray-dark-content);
}

.column-access-group {
    background-color: var(--color-pink);
    text-transform: capitalize;
}

.column-access-group-day-0:after,
.column-special-group-day-2:after {
    content: "";
    display: block;
    position: absolute;
    width: 1px;
    height: 18px;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.column-access-group-day {
    background-color: rgba(var(--color-pink-rgba), 0.8);
    text-transform: capitalize;
    position: relative;

    &.column-access-group-day-0:after {
        background: var(--color-pink-contrast);
    }
}

.column-special-group {
    background-color: var(--color-blue-light);
    text-transform: capitalize;
}

.column-special-group-day {
    background-color: rgba(var(--color-blue-light-rgba), 0.8);
    text-transform: capitalize;
    position: relative;

    &.column-special-group-day-2:after {
        background: var(--color-blue-light-contrast);
    }
}

.column-champions-parade {
    background-color: var(--color-orange-dark);
    text-transform: capitalize;
}

.column-champions-parade-day {
    background-color: rgba(var(--color-orange-dark-rgba), 0.8);
    text-transform: capitalize;
}
</style>

<script>
export default {
    props: {
        offday: {
            type: String,
            required: true
        },
        dates: {
            type: Array,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            dayoff: this.offday.replace("off-day-", "")
        };
    },

    methods: {
        groupsFrom(dates) {
            return dates;
        }
    }
};
</script>
